import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Appconfig } from 'src/app/configurations/appconfig';
import { CoreService } from '../core.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CanvasService extends CoreService {
  private _isCanvasActive: boolean = false;

  public get isCanvasActive(): boolean {
    return this._isCanvasActive;
  }
  public set isCanvasActive(value: boolean) {
    this._isCanvasActive = value;
  }
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  getTabs(type: any, stratId: any) {
    return this.get(
      Appconfig.APIENDPOINT.CANVAS.CORE +
      stratId +
      Appconfig.APIENDPOINT.CANVAS.LIST + type
    ).pipe(
      map((respData) => {
        return respData.body;
      })
    );
  }

  getCanvasData(type: any, stratId: any, tabId?: any) {
    return this.get(
      Appconfig.APIENDPOINT.CANVAS.CORE +
      stratId +
      Appconfig.APIENDPOINT.CANVAS.GET + type + (tabId ? '/' + tabId : '')
    ).pipe(
      map((respData) => {
        return respData.body;
      })
    );
  }

  saveCanvasData(data: any, stratId: any) {
    let postObj: any = data
    return this.post(
      Appconfig.APIENDPOINT.CANVAS.CORE +
      stratId +
      Appconfig.APIENDPOINT.CANVAS.CREATE,
      postObj
    ).pipe(
      map((respData) => {
        return respData.body;
      })
    );
  }

  deleteTab(id: any, stratId: any) {
    return this.delete(
      Appconfig.APIENDPOINT.CANVAS.CORE +
      stratId +
      Appconfig.APIENDPOINT.CANVAS.REMOVE + id
    ).pipe(
      map((respData) => {
        return respData.body;
      })
    );
  }

  reorderTabs(data: any, stratId: any) {
    return this.post(
      Appconfig.APIENDPOINT.CANVAS.CORE +
      stratId +
      Appconfig.APIENDPOINT.CANVAS.REORDER,
      data
    ).pipe(
      map((respData) => {
        return respData.body;
      })
    );
  }

}
